import { apiClient } from "../../../../../api/client";
import { ApiResponse } from "../../../../../types";
import {
  BloquearParams,
  BloqueioFiltros,
  BloqueioOpcoes,
  BloqueioResultado,
  DesbloquearParams,
  ListarBloqueiosResponse,
} from "../types";

// A ops do entregador vai como ops_entregador: o apiClient injeta ops = "gestor".
export const bloqueioService = {
  async opcoes(): Promise<ApiResponse<BloqueioOpcoes>> {
    return apiClient.post("/gestorBloqueio", { acao: "opcoes" });
  },

  async listar(params: {
    filtros: BloqueioFiltros;
    page: number;
    pageSize: number;
  }): Promise<ApiResponse<ListarBloqueiosResponse>> {
    return apiClient.post("/gestorBloqueio", { acao: "listar", ...params });
  },

  async bloquear(
    params: BloquearParams,
  ): Promise<ApiResponse<BloqueioResultado>> {
    return apiClient.post("/gestorBloqueio", { acao: "bloquear", ...params });
  },

  async desbloquear(
    params: DesbloquearParams,
  ): Promise<ApiResponse<BloqueioResultado>> {
    return apiClient.post("/gestorBloqueio", {
      acao: "desbloquear",
      ...params,
    });
  },
};
